import React, {useState} from 'react';
import { Circles } from 'react-loader-spinner';

const AvatarPicture = ({ picture, title }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="author">
      <div className="block block-one" />
      <div className="block block-two" />
      <div className="block block-three" />
      <div className="block block-four" />
      {!imgError && picture ? 
        <img
          alt="profile picture"
          className="avatar"
          src={picture} 
          onError={()=>{setImgError(true)}}
        />: 
        <Circles color="var(--bs-purple-pizzazz)" ariaLabel="loading animation" wrapperStyle={{ display: "block" }} wrapperClass="mb-3" />
      }
      <h5 className="title">{title}</h5>
    </div>
  );
};

export default AvatarPicture;
